import PropTypes from "prop-types";
import { TextField, FormControl } from "@mui/material";
import {
  readOnlyTextFieldStyles,
  labelStyles,
  formControlStyles
} from "./component-styles";
import "./readonly-styles.css";

const TextInputReadOnly = ({ label, value, ...rest }) => {
  return (
    <FormControl sx={formControlStyles} fullWidth>
      <TextField
        label={label}
        name={label}
        value={value || ""}
        className="readonly-field"
        sx={readOnlyTextFieldStyles}
        autoComplete="off"
        InputProps={{
          readOnly: true
        }}
        slotProps={{
          inputLabel: {
            sx: labelStyles,
            shrink: true
          }
        }}
        {...rest}
      />
    </FormControl>
  );
};

TextInputReadOnly.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
};
export default TextInputReadOnly;
